import { render, staticRenderFns } from "./tinymce_editor.vue?vue&type=template&id=5438dad1"
import script from "./tinymce_editor.vue?vue&type=script&lang=js"
export * from "./tinymce_editor.vue?vue&type=script&lang=js"
import style0 from "./tinymce_editor.vue?vue&type=style&index=0&id=5438dad1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports